export default [
  '1. 电子保单上所填写的信息是否为您本人填写并正确无误？',
  '2. 您是否已阅读并理解《人身保险投保提示书》，投保单及投保时的各项资料?  ',
  '3. 您对于合同条款，特别是保险责任、责任免除、保险期间等相关内容是否确认已清楚了解？',
  '4. 您是否清楚自您收到电子保险单次日起，享有10天的犹豫期，在犹豫期内您可以无条件解除保险合同。犹豫期后解除保险合同您会有一定的损失，我公司将按照合同约定退还保单的现金价值？',
  '(5) 被保险人过去两年内是否曾接受X光(包括乳房X线检查)、超声波检查、CT检查、活组织切片检查、血液检查、尿液检查、艾滋病检测或其他任何医学检查（不包括轻微疾病如伤风、感冒或常规体检）？',
  '(6) 被保人目前或曾经是否患有下列疾病或症状：高血压，糖尿病，恶性肿瘤，血管瘤，良性脑肿瘤，脑膜炎/脑炎，脊髓灰质炎，III度房室传导阻滞，冠心病，心肌炎，心肌病，肺动脉高压，心脑血管疾病，运动神经元病，癫痫，重症肌无力，多发性硬化，硬皮病，阿尔茨海默病，帕金森氏症，急性坏死性筋膜炎，精神类疾病，艾滋病或HIV感染，慢性肝炎或肝硬化、肺气肿、肺心病、呼吸功能衰竭、肾功能衰竭、多囊肾等肝肺肾脏器疾病，克隆病、溃疡性结肠炎、硬化性胆管炎等胆道肠道疾病，红斑狼疮，血液病或内分泌代谢疾病，胰腺炎，丝虫病，克-雅氏病，川崎病，嗜铬细胞瘤，肾上腺皮质功能减退， III度烧伤，职业病，风湿免疫性疾病、先天性疾病、遗传性疾病、体表或体内肿块、息肉、结节、黑痣增大、淋巴结肿大？',
  '(7) 是否有智能障碍、躯体畸形或功能障碍、肢体缺失？是否有言语、咀嚼、视力、听力等机能障碍？是否有酒精、药物滥用成瘾史以及使用毒品、镇静剂及其它违禁药物?',
  '(8) 被保险人目前是否从事高危职业?是否有参加飞行、潜水、滑水、漂流、跳伞、武术比赛、拳击比赛、赛车、蹦极、特技表演等危险运动的爱好？是否正计划到有战乱的国家工作或居住？',
  '(9) 被保人目前是否怀孕?（被保人为14周岁（含）以上女性时填写）',
  '(10) 您是否年收入低于  5万元，且本次所交保费高于年收入的35%？'
]



// WEBPACK FOOTER //
// ./src/data/feedbacks.js